import * as React from "react";
import styled from "styled-components";

import {
  sentenceCase,
  FontColors
} from "src/library/utils";

import { Text } from "../Text";

const LabelWrapper = styled("label")`
  color: ${({ theme }) => theme.fonts.colors.primary};
  font-size: ${({ theme }) => theme.fonts.sizes.h5};
  padding-bottom: 10px;
  display: block;

  &.disabled {
    opacity: 0.5;
  }
  .required {
    margin-left: 3px;
  }
`;

const Label: React.ReactFCWithChildren<{
  for: string;
  label: string;
  className?: string;
  color?: keyof FontColors;
  required?: boolean
}> = props => (
  <LabelWrapper
    htmlFor={props.for}
    className={props.className}
  >
    {props.children}

    <Text
      fontSize="h4"
      color={props.color || "primary"}
    >
      {sentenceCase(props.label)}

      <Text
        color="error"
        className="required"
      >
        {props.required ? "*" : ""}
      </Text>
    </Text>
  </LabelWrapper>
);

export default Label;
